import { render, staticRenderFns } from "./WeetPlayerCommentPreview.vue?vue&type=template&id=fa2b6f9a&scoped=true"
import script from "./WeetPlayerCommentPreview.vue?vue&type=script&lang=ts"
export * from "./WeetPlayerCommentPreview.vue?vue&type=script&lang=ts"
import style0 from "./WeetPlayerCommentPreview.vue?vue&type=style&index=0&id=fa2b6f9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2b6f9a",
  null
  
)

export default component.exports